import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

export const fetchDashboardData = async (period = "monthly") => {
  const response = await axiosInstance.get(`/dashboard`, { params: { period } });
  return response.data;
};